import { useEffect, useRef } from 'react';
import { Animated } from 'react-native';
import {
  JUMP_HIGHLIGHT_DURATION_MS,
  JUMP_HIGHLIGHT_NATIVE_OPACITY,
} from '../constants/diffView.constants';

// Returns an Animated.Value that flashes from peak opacity → 0 every time `tick`
// changes to a non-zero value. Native driver, so the fade runs off the JS thread.
export const useJumpHighlightOpacity = (tick: number | undefined): Animated.Value => {
  const opacity = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    if (!tick) {
      return;
    }
    opacity.setValue(JUMP_HIGHLIGHT_NATIVE_OPACITY);
    Animated.timing(opacity, {
      toValue: 0,
      duration: JUMP_HIGHLIGHT_DURATION_MS,
      useNativeDriver: true,
    }).start();
  }, [tick, opacity]);
  return opacity;
};
